import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export const getUserActivities = (params: any) =>
  api.get(url.GET_USER_ACTIVITIES, params);
export const postUserActivity = (data: any) =>
  api.create(url.POST_USER_ACTIVITY, data);
export const deleteUserActivity = (id: any) =>
  api.delete(url.DELETE_USER_ACTIVITY + "/" + id);
export const getPageTypes = (params: any) =>
  api.get(url.GET_PAGE_TYPES, params);
export const getUserActivityTrend = (params: any) =>
  api.get(url.GET_USER_ACTIVITY_TREND, params);
export const getUserActivityStats = (params: any) =>
  api.get(url.GET_USER_ACTIVITY_STATS, params);
export const getTopPages = (params: any) => api.get(url.GET_TOP_PAGES, params);
export const getDDSearches = (params: any) =>
  api.get(url.GET_DD_SEARCHES, params);
export const getMostViewedContent = (params: any) =>
  api.get(url.GET_MOST_VIEWED_CONTENT, params);
